import {JsonProperty} from '@hyperloris/tyson';

export class TableFilter {
  @JsonProperty()
  field?: string;
  @JsonProperty()
  value?: any;
  @JsonProperty()
  matchMode?: string;
  @JsonProperty()
  operator?: string;
}

export module TableFilter {
  export enum MATCH_MODE_TEXT {
    equals = 'equals',
    notEquals = 'notEquals',
    in = 'in',
    notIn = 'notIn',
    contains = 'contains',
    notContains = 'notContains',
    startsWith = 'startsWith',
    notStartsWith = 'notStartsWith',
    endsWith = 'endsWith',
    notEndsWith = 'notEndsWith',
    like = 'like',
    notLike = 'notLike',
    isNull = 'isNull',
    isNotNull = 'isNotNull',
  }

  export enum MATCH_MODE_DATE {
    dateIs = 'dateIs',
    dateIsNot = 'dateIsNot',
    dateAfter = 'dateAfter',
    dateBefore = 'dateBefore',
    dateAfterEquals = 'dateAfterEquals',
    dateBeforeEquals = 'dateBeforeEquals',
    isNull = 'isNull',
    isNotNull = 'isNotNull',
  }

  export enum MATCH_MODE_NUMBER {
    equals = 'equals',
    notEquals = 'notEquals',
    greaterThan = 'greaterThan',
    lessThan = 'lessThan',
    greaterEqualsThan = 'greaterEqualsThan',
    lessEqualsThan = 'lessEqualsThan',
    isNull = 'isNull',
    isNotNull = 'isNotNull',
  }

  export enum OPERATOR {
    and = 'and',
    or = 'or'
  }
}
